export const CHATUI_WINDOW_PATH = 'CarvanaChatUi';

export const CHAT_UI_MFER_MODULE = 'CarvanaChatUiModule';

// TODO<developer> Remove once all legacy code is updated
export const CHATUI_WINDOW_PATH_OLD = 'CarvanaAiChat';

export const CHAT_CHANNEL = 'chat';

export const VENDOR_NAME_CARVANA = 'Carvana';

export const ORIGIN_DEFAULT = 'carvana_homepage';

export const DD_RUM = 'DD_RUM';
